module.exports = __webpack_public_path__ + "img/vertical_3_4_8019.87930fc5.png";